import { Component, Input, OnInit } from "@angular/core";
import { CONSTANTS } from "app/constants";
import { FixtureFullDto } from "app/models/dtos/fixture-full.dto";
import { ConfigurationService, UtilsService } from "app/services";

@Component({
    selector: 'next-fixture',
    templateUrl: './next-fixture.component.html',
    styleUrls: ['./next-fixture.component.scss'],
})
export class NextFixture implements OnInit {
    @Input()
    fixture: FixtureFullDto;

    @Input()
    isNational: boolean;
    
    baseFintUrl: string;

    weathers: string[];

    const: any;

    constructor(configurationService: ConfigurationService, private utilsService: UtilsService) {
        this.baseFintUrl = configurationService.getFintFMUrl();
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildWeatherDictionary();
    }

    formatDate(timestamp: number): string {
        return this.utilsService.formatDate(timestamp);
    }

    getWeatherName(weather: number) {
        if (!weather)
            return null;

        return this.weathers[weather];
    }

    private buildWeatherDictionary() {
        this.weathers = [];
        this.weathers[CONSTANTS.weatherIds.sunny] = CONSTANTS.weatherNames.sunny;
        this.weathers[CONSTANTS.weatherIds.rain] = CONSTANTS.weatherNames.rain;
    }
}